import { CCol, CSmartTable } from '@coreui/react-pro'
import React, { useContext } from 'react'
import { LogContext } from 'src/context/LogContext'
import { formatDateTime } from 'src/utils/helpers'

const OrderLogsTable = () => {
  const { orderLogs, columns, isLoading, t } = useContext(LogContext)

  return (
    <CSmartTable
      items={orderLogs.data}
      itemsPerPage={+orderLogs.per_page}
      columns={columns}
      noItemsLabel={t(isLoading ? 'loading' : 'no-items')}
      columnSorter={true}
      loading={isLoading}
      scopedColumns={{
        order_id: (item) => <td className="text-center">{item.order_id || t('n-a')}</td>,
        action: (item) => <td className="text-center">{item.action || t('n-a')}</td>,
        previous_properties: (item) => <td>{item.previous_properties || t('n-a')}</td>,
        properties: (item) => <td>{item.properties || t('n-a')}</td>,
        note: (item) => <td>{item.note || t('n-a')}</td>,
        created_by_name: (item) => <td>{item.created_by_name || t('n-a')}</td>,
        synch_status: (item) => <td>{item.synch_status || t('n-a')}</td>,
        synch_message: (item) => <td>{item.synch_message || t('n-a')}</td>,
        deleted_by: (item) => <td>{item.deleted_by || t('n-a')}</td>,
        created_at: (item, index) => (
          <td key={'create_at' + index}>
            <CCol>
              {item?.created_at && formatDateTime(item?.created_at)}
              <br />
              <small className="text-disabled text-nowrap">{item?.created_by || ''}</small>
            </CCol>
          </td>
        ),
        updated_at: (item, index) => (
          <td key={'updated_at' + index}>
            <CCol>
              {item?.updated_at && formatDateTime(item?.updated_at)}
              <br />
              <small className="text-disabled text-nowrap">{item?.updated_by || ''}</small>
            </CCol>
          </td>
        ),
      }}
      tableProps={{
        hover: true,
        striped: true,
        bordered: true,
        responsive: true,
      }}
      tableHeadProps={{
        align: 'start',
      }}
    />
  )
}

export default OrderLogsTable
